<template>
  <v-container>
    <div class="breadcrumbs-wrap">
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
    </div>
    <h1 class="title-pg">{{ $t('Квоты') }} > {{ $t('Аннулирование квоты') }} {{ quotaCancellation.ooptTransName }}</h1>
    <div class="my-organization">
      <div v-cloak class="create-quota-pg view bgw-pdg-20">
        <p v-if="quotaCancellation.status" class="status text-center">
          {{ $t('Статус') }}: {{ quotaCancellation.status.transName }}
        </p>
        <h4 class="text-center">{{ $t('Аннулирование квоты на добычу диких животных') }}
          {{ quotaCancellation.ooptTransName }}</h4>
        <!--таблица-->
        <div class="table-overflow" v-if="quotas.length > 0">
          <table class="table-full">
            <thead>
            <tr>
              <td>{{ $t('Вид животного') }}</td>
              <td class="text-center">{{ $t('Лимит') }}</td>
              <td class="text-center">{{ $t('Кол-во выданных ранее') }}</td>
              <td class="text-center">{{ $t('Кол-во использованных') }}</td>
              <td class="text-center">{{ $t('Кол-во аннулированных') }}</td>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, i) in quotas" :key="i">
              <td>{{ item.faunaName }}</td>
              <td class="text-center">{{ item.limitHeadQuantity }}</td>
              <td class="text-center">{{ item.limitHeadQuantityQuota }}</td>
              <td class="text-center">0</td>
              <td class="text-center">{{ item.headCount }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <!--Дата-Приказ-Комментарии-Пользователь-->
        <div class="form-group">
          <p>
            <span v-if="quotaCancellation.date">{{ $t('Дата') }}: {{ quotaCancellation.date }}</span>
            <span>{{ quotaCancellation.documentDetails }}</span>
          </p>
          <div v-if="quotaCancellation.file">
            <template
              v-if="checkFileExist(quotaCancellation.fileExtension)"
            >
              <p>
                <a
                  @click="previewDocumentDialog(quotaCancellation.id, true)"
                >{{ $t('Файл документа') }}</a>
              </p>
              <v-dialog
                v-model="previewDocsModal[quotaCancellation.id]"
                max-width="1200"
              >
                <v-card class="modal">
                  <div class="modal-head">
                    {{ $t('Файл документа') }}
                    <v-btn
                      color="modal-close"
                      @click="previewDocumentDialog(quotaCancellation.id, false)"
                    >
                      <img src="@/assets/img/close-icon.png" alt="icon">
                    </v-btn>
                  </div>
                  <div class="modal-body">
                    <VueDocPreview
                      :value="backUrl + quotaCancellation.file"
                      type="office"
                    />
                  </div>
                </v-card>
              </v-dialog>
            </template>
            <template v-else>
              <a
                :href="backUrl + quotaCancellation.file"
                target="_blank"
              >{{ $t('Файл документа') }}</a>
            </template>
          </div>
          <p>{{ $t('Комментарии') }}: {{ quotaCancellation.comment }}</p>
          <p v-if="lastHistory">{{ lastHistory.userFio }}</p>
        </div>
        <!--кнопки действии-->
        <div class="form-action">
          <button
            class="btn btn-default blue"
            type="button"
            @click="onEdit"
            v-if="quotaCancellation.status.id === quotaCancellation.draftStatus"
          >
            {{ $t('Редактировать') }}
          </button>
          <button
            class="btn btn-default gray"
            type="button"
            @click="onCancel"
          >
            {{ $t('Закрыть') }}
          </button>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import Quota from '@/model/quota'
import VueDocPreview from 'vue-doc-preview'
import { mapMutations } from 'vuex'

export default {
  components: {
    VueDocPreview
  },
  data: () => ({
    breadcrumbs: [],
    quotaCancellation: {},
    quotas: [],
    previewDocsModal: [],
    lastHistory: {},
    backUrl: process.env.VUE_APP_BACK_URL,
    isSpecialist: false,
    ooptId: null
  }),
  mounted () {
    this.fetchData()
    this.scrollToTop()
  },
  methods: {
    ...mapMutations(['setLoading']),
    fetchData () {
      this.setLoading(true)
      Quota.getQuotaCanceledInfo(this.$route.params.id).then((response) => {
        this.quotaCancellation = response.data
        this.lastHistory = response.data.lastHistory
        this.quotas = response.data.quotas
        this.isSpecialist = response.data.isSpecialist
        this.ooptId = response.data.ooptId
        this.generateBreadcrumbs()
      })
        .catch((error) => {
          this.$router.push({
            name: 'error',
            params: {
              status: error.response.status
            }
          })
        })
      this.setLoading(false)
    },
    // генерация хлебных крошек
    generateBreadcrumbs () {
      this.breadcrumbs = [
        {
          text: this.$i18n.t('Главная'),
          disabled: false,
          href: '/'
        },
        {
          text: this.$i18n.t('Рабочий кабинет'),
          disabled: false,
          href: '/my-organization'
        },
        {
          text: this.$i18n.t('Квоты'),
          disabled: false,
          href: this.isSpecialist === true ? '/society/quotas/' + this.ooptId : '/quotas'
        },
        {
          text: this.$i18n.t('Аннулирование квоты на добычу диких животных') + ' ' + this.quotaCancellation.ooptTransName,
          disabled: true
        }
      ]
    },
    // Прокручивание к началу страницы
    scrollToTop () {
      window.scrollTo(0, 0)
    },
    // Отмена
    onCancel () {
      this.isSpecialist === true
        ? this.$router.push({
          name: 'society-quotas',
          params: {
            id: this.ooptId
          }
        })
        : this.$router.push({
          name: 'quotas'
        })
    },
    // Отмена
    onEdit () {
      this.$router.push({
        name: 'quota-cancellation-edit',
        params: {
          id: this.$route.params.id
        }
      })
    },
    checkFileExist (ext) {
      const fileExtensions = ['doc', 'docx', 'xls', 'xlsx']
      const exist = fileExtensions.some(function (field) {
        return field === ext
      })
      return exist
    },
    // предпросмотр файлов
    previewDocumentDialog (id, flag) {
      this.$set(this.previewDocsModal, id, flag)
    }
  }
}
</script>

<style lang="scss" scoped>
.search-head {
  margin-bottom: 20px;
}

table {
  td {
    .v-input {
      margin: 0 auto;
    }
  }
}
</style>
